import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { ConfigService } from '../config/config-service';
import { SessionService } from './session.service';

@Injectable()
export class GastoService {
    private config: ConfigService;
    private _token: any;
    private host_api: String;
    private dbname: string;

    constructor(private http: Http, private ss: SessionService) { 
      this.config = new ConfigService();
      this.host_api = this.ss.getData('host_api');
      this._token = sessionStorage.getItem('api-token');
      this.dbname = this.ss.getData('dbname');
    }

    getAll(queryString: String = ""){
      let url = this.host_api + "/compras/gastos" + queryString;
      let headers = new Headers({'Accept' : 'Application/json'});
      headers.append('Authorization',"Bearer "+ this._token);
      headers.append('dbname',this.dbname);
      let options = new RequestOptions({headers : headers});

      return this.http.get(url,options).map( (res:Response) => {
        return this.config.onSuccessResponse(res);
      }).catch( (error:any) => {
        return this.config.onErrorResponse(error);
      });
    }

    save(Gasto) {
      let url = this.host_api + '/compras';
      let params = Gasto;//JSON.stringify(categoria);
      let headers = new Headers({ 'Content-type': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
  
      let options = new RequestOptions({ headers: headers });
  
      return this.http.post(url, params, options).map((res:Response) => {	
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });		
  
    }

    getById(id, qs: String =""){
      let url = this.host_api + '/compras/gastos/' + id + qs;
      let headers = new Headers({ 'Accept': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.get(url, options).map((res:Response) => {	
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });	
    }

    delete(id) {
      var url = this.host_api + '/compras/gastos/' + id + '/del';
      let params = {usuario_id: this.ss.getData('usuario_id')};
      let headers = new Headers({ 'Content-type': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.put(url, params, options).map((res:Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });		
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/gasto.service.ts